import { Box } from '@mentimeter/ragnar-ui/box';
import { LoaderIcon } from '@mentimeter/ragnar-visuals';
import { ICON_SIZE } from './constants';

export const QfaLoader = ({ shouldShow }: { shouldShow: boolean }) => {
  return (
    <Box
      position="absolute"
      mt={5}
      extend={({ theme }) => ({
        opacity: shouldShow ? 1 : 0,
        transition: `opacity ${theme.durations[1]}s ease`,
      })}
    >
      <LoaderIcon size={ICON_SIZE} color="textWeak" />
    </Box>
  );
};
